import { createMetricsFactory, setStaticAppInfo } from 'metrics-js';
setStaticAppInfo({
  package: 'email-management-ui',
  version: 'static'
});
export const Metrics = createMetricsFactory('email-management-ui', {
  library: 'email-management-ui'
});